import React from 'react';
import { GenericDetailPage } from '../../../components/generic';
import { useAppDuration, AppDuration } from './useData';
import { moduleConfig, getDetailSections, getStatusBadges } from './config';

const Detail: React.FC = () => {
  return (
    <GenericDetailPage<AppDuration>
      useData={useAppDuration}
      config={{
        ...moduleConfig,
        getDetailSections,
        getStatusBadges,
      }}
    />
  );
};

export default Detail;
